(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bark-potty-swap-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function attachCaptionsFromSectionSetting(scope) {
    (scope || document).querySelectorAll('.bark-potty-potty-swap-video__embed--html5').forEach(function (embed) {
      var payload = embed.querySelector('script.bark-potty-vtt-settings');
      var video = embed.querySelector('video');
      if (!payload || !video || video.getAttribute('data-bark-potty-vtt-attached') === '1') return;
      var raw;
      try {
        raw = JSON.parse(payload.textContent);
      } catch (e) {
        return;
      }
      if (!raw || typeof raw !== 'string') return;
      var track = document.createElement('track');
      track.kind = 'captions';
      track.label = 'English';
      track.srclang = 'en';
      track.default = true;
      track.src = URL.createObjectURL(new Blob([raw], { type: 'text/vtt' }));
      video.appendChild(track);
      video.setAttribute('data-bark-potty-vtt-attached', '1');
    });
  }

  function showHtml5CaptionsByDefault(scope) {
    var root = scope || document;
    root.querySelectorAll('.bark-potty-potty-swap-video__embed--html5 video').forEach(function (video) {
      function apply() {
        var tracks = video.textTracks;
        if (!tracks || !tracks.length) return;
        for (var i = 0; i < tracks.length; i++) {
          var tr = tracks[i];
          if (tr.kind === 'captions' || tr.kind === 'subtitles') {
            tr.mode = 'showing';
            return;
          }
        }
      }
      apply();
      ['loadedmetadata', 'loadeddata', 'canplay', 'playing'].forEach(function (name) {
        video.addEventListener(name, apply);
      });
      if (video.textTracks && typeof video.textTracks.addEventListener === 'function') {
        video.textTracks.addEventListener('addtrack', apply);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachCaptionsFromSectionSetting(document);
    showHtml5CaptionsByDefault(document);
  });
  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target) return;
    attachCaptionsFromSectionSetting(ev.target);
    showHtml5CaptionsByDefault(ev.target);
  });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-bark-potty-swap-cta]');
    if (!t) return;
    var sel = t.getAttribute('data-scroll-target');
    if (!sel) return;
    var el = document.querySelector(sel);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.tab-button-wrapper .tab-button');
  tabButtons.forEach(function(button) {
    if (button.textContent.trim() === 'Bark Potty') {
      button.addEventListener('click', function() {
        if (typeof dataLayer !== 'undefined') {
          dataLayer.push({
            event: 'outbound_barkpotty_click',
            link_text: 'Bark Potty'
          });
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
